import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
import App from './App';
import './config/i18n/i18n';
import { NotificationProvider } from '@iziping/ui';
import ReactQueryProvider from './config/ReactQueryProvider';
import { loadConfig } from './config/appConfig';

loadConfig().then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        <React.StrictMode>
            <NotificationProvider>
                <ReactQueryProvider>
                    <App />
                </ReactQueryProvider>
            </NotificationProvider>
        </React.StrictMode>
    );
});
